import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';
import { TranslateService,LangChangeEvent } from '@ngx-translate/core';
@Component({
  selector: 'app-voucher-settings',
  templateUrl: './voucher-settings.component.html',
  styleUrls: ['./voucher-settings.component.css']
})
export class VoucherSettingsComponent implements OnInit {


  display = [
    { id: 0, name: 'Hide' },
    { id: 1, name: 'Display' },
  ];
  pageLoadingImg: boolean;
  vsettings: any;
  jrnl_cb_display: any;
  constructor(private apiService: ApiService, private coreService: CoreService,private translate: TranslateService) { }

  ngOnInit() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.getVoucherSetting();
  }
  getVoucherSetting() {

    this.apiService.getVoucherSetting().subscribe((res) => {
      if (res['data']) {
        this.vsettings = res['data'];
        this.jrnl_cb_display = this.vsettings.vs_cash_bank_journal;
       

      }
    });

  }

  update(formdata: { value: any; }) {
    this.pageLoadingImg = true;

    this.apiService.updateVoucherSettings(formdata.value).subscribe((res) => {
      this.pageLoadingImg = false;
      if (res.data) {
        this.coreService.showMessage('Setting Saved');

      }
    }, (error) => {
      this.pageLoadingImg = false;
    });
  }
  langChange(){
    this.translate.get(['HOME.hide', 'HOME.show',
  ]).subscribe((res: string) => {    
     

      this.display = [
        { id: 0, name: res['HOME.hide']},
        { id: 1, name: res['HOME.show'] },
        
      ];
    
    });

}
}
